export default __webpack_public_path__ + "static/media/feature-box-collection-road-trip2-550x310.58016ea1.png";